import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=38b8fad4&scoped=true"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"
import style0 from "./DownloadView.vue?vue&type=style&index=0&id=38b8fad4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8fad4",
  null
  
)

export default component.exports